import { useEffect, useState } from 'react';
import { useAccessToken } from '../auth/use-access-token.js';
import { listChildTeams, type MyTeamPillRow } from '../api/my-teams.js';
import type { Person } from '../api/use-people.js';
import { TeamPill } from './team-pill.js';

/**
 * A child's teams on their page (mockup *Teams*, board 8, approved 25
 * October): a My Team pill for each, opening My Team as the child sees it.
 * Nothing when the child is on no team.
 *
 * THE TWO SWITCHES ARE HIDDEN ("Teammates can see <name>'s Performance
 * Signature" and "Team coaches can see <name>'s lessons"). Matthew, 28
 * October: "the wrong level for this page and for now the default is on so
 * dont show it until I decide where to put it". The server treats both as on;
 * the saved settings and their history are kept for when they come back
 * (saveTeammatesCanSee, saveTeamCoachesSeeLessons).
 */
export function ChildTeams({ person }: { person: Person }) {
  const getToken = useAccessToken();
  const [teams, setTeams] = useState<MyTeamPillRow[]>([]);

  useEffect(() => {
    let live = true;
    listChildTeams(getToken, person.client_id)
      .then((found) => {
        if (live) setTeams(found.teams);
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [getToken, person.client_id]);

  return (
    <>
      {teams.map((team) => (
        <TeamPill key={team.team_id} team={team} child={person.client_id} />
      ))}
    </>
  );
}
